import { apiClient } from './apiClient';
import type { Notification, NotificationSummary } from '../types';

export const notificationApi = {
  async list(unreadOnly?: boolean): Promise<Notification[]> {
    const params = unreadOnly !== undefined ? { unread_only: unreadOnly } : {};
    const response = await apiClient.get('/api/notifications', { params });
    return response.data;
  },

  async get(id: number): Promise<Notification> {
    const response = await apiClient.get(`/api/notifications/${id}`);
    return response.data;
  },

  async getSummary(): Promise<NotificationSummary> {
    const response = await apiClient.get('/api/notifications/summary');
    return response.data;
  },

  async markAsRead(id: number): Promise<Notification> {
    const response = await apiClient.patch(`/api/notifications/${id}/read`);
    return response.data;
  },

  async markAllAsRead(): Promise<{ message: string; count: number }> {
    const response = await apiClient.post('/api/notifications/read-all');
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/notifications/${id}`);
  },

  async generateReminders(): Promise<{ message: string; count: number }> {
    const response = await apiClient.post('/api/notifications/generate-reminders');
    return response.data;
  },
};
